import { Component, OnInit, computed, inject, input, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CountriesService } from '../../../core/services/countries.service';
import { countryFlag } from '../../../core/constants/countries.constants';

@Component({
  selector: 'app-country-phone-input',
  imports: [FormsModule],
  templateUrl: './country-phone-input.component.html',
  styleUrl: './country-phone-input.component.scss'
})
export class CountryPhoneInputComponent implements OnInit {
  private readonly countriesService = inject(CountriesService);

  readonly country = model<string>('India');
  readonly phoneNumber = model<string>('');
  readonly placeholder = input('Enter your phone number');

  protected readonly countries = this.countriesService.list;
  protected readonly countryFlag = countryFlag;

  protected readonly countryMenuOpen = signal(false);
  protected readonly countrySearch = signal('');

  protected readonly filteredCountries = computed(() => {
    const query = this.countrySearch().trim().toLowerCase();
    if (!query) return this.countries();
    return this.countries().filter((item) => item.name.toLowerCase().includes(query));
  });

  protected readonly selectedCountry = computed(() =>
    this.countries().find((item) => item.name === this.country())
  );

  protected readonly selectedCountryFlag = computed(() =>
    this.selectedCountry() ? countryFlag(this.selectedCountry()!.code) : '🌐'
  );

  protected readonly selectedCountryDialCode = computed(() => this.selectedCountry()?.dialCode ?? '');

  ngOnInit(): void {
    this.countriesService.loadCountries().subscribe();
  }

  toggleCountryMenu(): void {
    this.countryMenuOpen.update((open) => !open);
    if (!this.countryMenuOpen()) this.countrySearch.set('');
  }

  selectCountry(name: string): void {
    this.country.set(name);
    this.countryMenuOpen.set(false);
    this.countrySearch.set('');
  }
}
